import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    if (user && user.id) {
        navigate("/dashboard", { replace: true });
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        const ok = await login(email, password);
        setBusy(false);
        if (ok) navigate("/dashboard");
        else setError("Invalid email or password.");
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-6" data-testid="login-page">
            <div className="w-full max-w-sm">
                <div className="text-center mb-8">
                    <img
                        src="/jra-logo.png"
                        alt="Joseph Roberts Africa"
                        className="h-24 w-auto mx-auto mb-4"
                        data-testid="login-logo"
                    />
                    <div className="font-heading text-3xl font-extrabold tracking-tighter leading-none mb-1">
                        Joseph Roberts Group
                    </div>
                    <div className="overline mb-3">Reports Control Room</div>
                    <div className="text-sm text-muted2">Sign in to continue</div>
                </div>
                <form onSubmit={onSubmit} className="grid-card p-7 space-y-5" data-testid="login-form">
                    <div>
                        <label className="overline block mb-1.5">Email</label>
                        <input
                            data-testid="login-email"
                            type="email"
                            className="input-base"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            required
                        />
                    </div>
                    <div>
                        <label className="overline block mb-1.5">Password</label>
                        <input
                            data-testid="login-password"
                            type="password"
                            className="input-base"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                    </div>
                    {error ? (
                        <div className="text-xs text-neg border border-neg/40 bg-neg/5 px-3 py-2 rounded-sm" data-testid="login-error">{error}</div>
                    ) : null}
                    <button
                        data-testid="login-submit"
                        type="submit"
                        disabled={busy}
                        className="w-full bg-ink text-paper py-3 rounded-sm font-medium text-sm tracking-wide hover:bg-klein transition-colors disabled:opacity-60"
                    >
                        {busy ? "Signing in…" : "SIGN IN"}
                    </button>
                    <div className="text-xs text-muted2 pt-3 border-t border-rule text-center">
                        <Link to="/forgot-password" className="underline" data-testid="forgot-link">Forgot password</Link>
                    </div>
                </form>
                <div className="text-[11px] text-faint text-center mt-6 tracking-wide">
                    Private internal portal · access by invitation only
                </div>
            </div>
        </div>
    );
}
